import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import AppWithModal from "./AppWithModal";

// Check if modal mode is enabled via URL parameter or environment variable
const urlParams = new URLSearchParams(window.location.search);
const isModalMode = urlParams.get("modal") === "true" || process.env.REACT_APP_MODAL_MODE === "true";

const themeParam = urlParams.get("theme");
// Set theme mode based on URL parameter or default to light
const themeMode = themeParam === "dark" ? "dark" : "light";
window.__ASKBLAZE_THEME_MODE__ = themeMode;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<React.StrictMode>{isModalMode ? <AppWithModal /> : <App />}</React.StrictMode>);
